import { render, staticRenderFns } from "./DoKoStack.vue?vue&type=template&id=c85bc260&scoped=true&"
import script from "./DoKoStack.vue?vue&type=script&lang=ts&"
export * from "./DoKoStack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85bc260",
  null
  
)

/* custom blocks */
import block0 from "./DoKoStack.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports